import React from "react"
import { Route } from "react-router";
import { IMenu, IMenuModel } from "../models/MenuItems";

import * as Dispatcher from './../Dispatcher'
import { IAuthService } from "../services/security/AuthService";
import { IAppLayoutService } from "../services/shared/AppLayout";

import container from './../wires/Bootstrapper'
import SERVICE_IDENTIFIER from './../wires/Identifiers'

const RenderRoute = (data: IMenu) => {
    const CP = Dispatcher[data.componentKey];
    if (CP == null)
        throw new Error(`Creare l'export per il componente ${data.componentKey}  in Dispatcher.Ts`);

    return <CP key={Math.random().toString(36).substr(2, 9) }/>
}

const PrintRoute = (data: IMenu) => {
    if (data.menu != null && data.menu.length > 0)
        return data.menu.map(PrintRoute)

    if (data.route != null)
        return <Route key={data.id} path={data.route} exact={data.route == "/"} render={() => RenderRoute(data)} />
}

class AppRoutesState {
    menu: IMenuModel
}

export class AppRoutes extends React.Component<any, AppRoutesState> {

    authService: IAuthService
    service: IAppLayoutService

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.APPLAYOUT_SERVICE);
        this.authService = container.get(SERVICE_IDENTIFIER.AUTH_SERVICE);

        this.state = {
            menu: { menu: [] }
        }
    }

    async componentDidMount() {
        if (this.authService.isAuthenticated()) {
            let resp = await this.service.getMenuForRoute()
            this.setState({ menu: resp })
        }
    }

    render() {
        return <>
            {this.state.menu.menu.map(PrintRoute)}
        </>
    }
}